import * as React from "react";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ProbationTimeOverlay } from "../ProbationTimeOverlay";
import { MasterDetailCoopProjects } from "./MasterDetailCoopProjects";
export var TabCoopProjects = function () {
    return (React.createElement(ProbationTimeOverlay, { idLoca: IdLoca.joinCoop_blockedProjects_desc },
        React.createElement(MasterDetailCoopProjects, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/TabCoopProjects.tsx
// module id = 2587
// module chunks = 3